import { Controller } from "@hotwired/stimulus"
import { visit } from "@hotwired/turbo"

// Simple swipe navigation for calendar - no animations, just detect and navigate
export default class extends Controller {
  static values = {
    prevUrl: String,
    nextUrl: String
  }

  connect() {
    this.startX = null
    this.startY = null
    this.threshold = 50 // minimum swipe distance in pixels
  }

  handleTouchStart(event) {
    const touch = event.touches[0]
    this.startX = touch.clientX
    this.startY = touch.clientY
  }

  handleTouchEnd(event) {
    if (this.startX === null || this.startY === null) return

    const touch = event.changedTouches[0]
    const endX = touch.clientX
    const endY = touch.clientY
    const diffX = endX - this.startX
    const diffY = endY - this.startY

    // Only handle horizontal swipes (ignore vertical scrolling)
    if (Math.abs(diffX) > Math.abs(diffY) && Math.abs(diffX) > this.threshold) {
      if (diffX > 0) {
        // Swiped right - go to previous month
        visit(this.prevUrlValue, { frame: "events_calendar" })
      } else {
        // Swiped left - go to next month
        visit(this.nextUrlValue, { frame: "events_calendar" })
      }
    }

    this.startX = null
    this.startY = null
  }
}
